{
  "sidebarLinks": [
    {
      "title": "Security Operations",
      "route": "",
      "iconImg": "fa-shield-virus",
      "count": null,
      "sub_links": [
        {
          "title": "Ninja-Agent-X",
          "route": "",
          "iconImg": "fa-robot",
          "count": null,
          "sub_links": [
            {
              "title": "Scanners",
              "route": "/dashboard/ninja-scanners",
              "iconImg": "fa-robot",
              "count": null,
              "requiredFeature": "scanners"
            },
            {
              "title": "Scans",
              "route": "/dashboard/ninja-scanners/scans",
              "iconImg": "fa-satellite-dish",
              "countType": "ninja-scans",
              "requiredFeature": "scanners"
            },
            {
              "title": "Assets",
              "route": "/dashboard/ninja-scanners/assets",
              "iconImg": "fa-server",
              "count": null,
              "requiredFeature": "scan_assets"
            },
            {
              "title": "Discovered Inventory",
              "route": "/dashboard/ninja-scanners/inventory",
              "iconImg": "fa-network-wired",
              "count": null,
              "requiredFeature": "scan_assets"
            },
            {
              "title": "Agent Artifacts",
              "route": "/dashboard/ninja-scanners/agent-artifacts",
              "iconImg": "fa-shield-halved",
              "count": null,
              "requiredFeature": "scan_assets"
            }
          ]
        },
        {
          "title": "Tenable.io",
          "route": "",
          "iconImg": "fa-satellite-dish",
          "count": null,
          "sub_links": [
            {
              "title": "Scanners",
              "route": "/dashboard/scanners",
              "iconImg": "fa-satellite-dish",
              "countType": "scanners",
              "requiredFeature": "scanners"
            },
            {
              "title": "Scans",
              "route": "/dashboard/scans",
              "iconImg": "fa-file-lines",
              "countType": "scans",
              "requiredFeature": "view_scans"
            },
            {
              "title": "Assets",
              "route": "/dashboard/scan-assets",
              "iconImg": "fa-boxes-stacked",
              "countType": "assets",
              "requiredFeature": "scan_assets"
            }
          ]
        }
      ]
    },
    {
      "title": "Compliance Programs",
      "route": "",
      "iconImg": "fa-shield-halved",
      "count": null,
      "sub_links": [
        { "title": "Control Impact", "route": "/dashboard/control-impact", "iconImg": "fa-scale-balanced", "count": null },
        { "title": "Audit Evidence", "route": "/dashboard/control-impact/evidence", "iconImg": "fa-file-shield", "count": null },
        {
          "title": "SOC 2",
          "route": "",
          "iconImg": "fa-shield",
          "count": null,
          "sub_links": [
            { "title": "Overview", "route": "/dashboard/compliance/soc2-overview", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Control Matrix", "route": "/dashboard/compliance/control-matrix", "iconImg": "fa-table-cells", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Data Retention", "route": "/dashboard/compliance/data-retention", "iconImg": "fa-database", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Incidents", "route": "/dashboard/compliance/incidents", "iconImg": "fa-triangle-exclamation", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Evidence", "route": "/dashboard/compliance/evidence", "iconImg": "fa-folder-open", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Audit Preparation", "route": "/dashboard/compliance/audit-prep", "iconImg": "fa-clipboard-check", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Tasks", "route": "/dashboard/compliance/tasks", "iconImg": "fa-tasks", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" },
            { "title": "Policies", "route": "/dashboard/compliance/policies", "iconImg": "fa-file-contract", "count": null, "requiredFeature": "soc2_compliance", "requiredAddon": "soc2_certification" }
          ]
        },
        {
          "title": "PCI DSS",
          "route": "",
          "iconImg": "fa-shield-alt",
          "count": null,
          "sub_links": [
            { "title": "Overview", "route": "/dashboard/pci-compliance", "iconImg": "fa-dashboard", "count": null, "requiredFeature": "pci_compliance", "requiredAddon": "pci_certification" },
            { "title": "SAQ Management", "route": "/dashboard/pci-compliance/saq-management", "iconImg": "fa-clipboard-check", "count": null, "requiredFeature": "pci_compliance", "requiredAddon": "pci_certification" },
            { "title": "Tasks", "route": "/dashboard/pci-compliance/compliance-tasks", "iconImg": "fa-tasks", "count": null, "requiredFeature": "pci_compliance", "requiredAddon": "pci_certification" }
          ]
        },
        {
          "title": "NIST CSF 2.0",
          "route": "",
          "iconImg": "fa-layer-group",
          "count": null,
          "sub_links": [
            { "title": "Overview", "route": "/dashboard/csf2-compliance", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Govern", "route": "/dashboard/csf2-compliance/govern", "iconImg": "fa-landmark", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Identify", "route": "/dashboard/csf2-compliance/identify", "iconImg": "fa-magnifying-glass", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Protect", "route": "/dashboard/csf2-compliance/protect", "iconImg": "fa-shield-halved", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Detect", "route": "/dashboard/csf2-compliance/detect", "iconImg": "fa-satellite-dish", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Respond", "route": "/dashboard/csf2-compliance/respond", "iconImg": "fa-truck-medical", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Recover", "route": "/dashboard/csf2-compliance/recover", "iconImg": "fa-rotate-left", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Subcategories", "route": "/dashboard/csf2-compliance/subcategories", "iconImg": "fa-list-check", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Evidence", "route": "/dashboard/csf2-compliance/evidence", "iconImg": "fa-folder-open", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Tasks", "route": "/dashboard/csf2-compliance/tasks", "iconImg": "fa-list-ul", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" },
            { "title": "Audit Preparation", "route": "/dashboard/csf2-compliance/audit-prep", "iconImg": "fa-clipboard-check", "count": null, "requiredFeature": "csf2_compliance", "requiredAddon": "csf2_certification" }
          ]
        },
        {
          "title": "AIUC-1",
          "route": "",
          "iconImg": "fa-robot",
          "count": null,
          "sub_links": [
            { "title": "Overview", "route": "/dashboard/aiuc1-compliance", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "aiuc1_compliance", "requiredAddon": "aiuc1_certification" },
            { "title": "Security", "route": "/dashboard/aiuc1-compliance/security", "iconImg": "fa-shield-halved", "count": null, "requiredFeature": "aiuc1_compliance", "requiredAddon": "aiuc1_certification" },
            { "title": "Safety", "route": "/dashboard/aiuc1-compliance/safety", "iconImg": "fa-circle-check", "count": null, "requiredFeature": "aiuc1_compliance", "requiredAddon": "aiuc1_certification" },
            { "title": "Reliability", "route": "/dashboard/aiuc1-compliance/reliability", "iconImg": "fa-gear", "count": null, "requiredFeature": "aiuc1_compliance", "requiredAddon": "aiuc1_certification" },
            { "title": "Evidence", "route": "/dashboard/aiuc1-compliance/evidence", "iconImg": "fa-folder-open", "count": null, "requiredFeature": "aiuc1_compliance", "requiredAddon": "aiuc1_certification" },
            { "title": "Audit Preparation", "route": "/dashboard/aiuc1-compliance/audit-prep", "iconImg": "fa-clipboard-check", "count": null, "requiredFeature": "aiuc1_compliance", "requiredAddon": "aiuc1_certification" }
          ]
        },
        {
          "title": "CMMC 2.0",
          "route": "",
          "iconImg": "fa-shield-halved",
          "count": null,
          "sub_links": [
            { "title": "Overview", "route": "/dashboard/cmmc-compliance", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" },
            { "title": "SPRS Dashboard", "route": "/dashboard/cmmc-compliance/sprs", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" },
            { "title": "Quantum Readiness", "route": "/dashboard/cmmc-compliance/quantum", "iconImg": "fa-atom", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" },
            { "title": "PoAM", "route": "/dashboard/cmmc-compliance/poam", "iconImg": "fa-list-check", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" },
            { "title": "Evidence", "route": "/dashboard/cmmc-compliance/evidence", "iconImg": "fa-folder-open", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" },
            { "title": "Scoping", "route": "/dashboard/cmmc-compliance/scoping", "iconImg": "fa-object-group", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" },
            { "title": "Audit Preparation", "route": "/dashboard/cmmc-compliance/audit-prep", "iconImg": "fa-clipboard-check", "count": null, "requiredFeature": "cmmc_compliance", "requiredAddon": "cmmc_certification" }
          ]
        },
        {
          "title": "Privacy",
          "route": "",
          "iconImg": "fa-scale-balanced",
          "count": null,
          "sub_links": [
            { "title": "GDPR Overview", "route": "/dashboard/gdpr-compliance", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "gdpr_compliance", "requiredAddon": "gdpr_certification" },
            { "title": "SAR Tracker", "route": "/dashboard/gdpr-compliance/sar-tracker", "iconImg": "fa-inbox", "count": null, "requiredFeature": "gdpr_compliance", "requiredAddon": "gdpr_certification" },
            { "title": "RoPA", "route": "/dashboard/gdpr-compliance/ropa", "iconImg": "fa-file-contract", "count": null, "requiredFeature": "gdpr_compliance", "requiredAddon": "gdpr_certification" },
            { "title": "Lawful Bases", "route": "/dashboard/gdpr-compliance/lawful-bases", "iconImg": "fa-gavel", "count": null, "requiredFeature": "gdpr_compliance", "requiredAddon": "gdpr_certification" },
            { "title": "DPIA", "route": "/dashboard/gdpr-compliance/dpia", "iconImg": "fa-magnifying-glass-chart", "count": null, "requiredFeature": "gdpr_compliance", "requiredAddon": "gdpr_certification" },
            { "title": "DPA Tracker", "route": "/dashboard/gdpr-compliance/dpa-tracker", "iconImg": "fa-handshake", "count": null, "requiredFeature": "gdpr_compliance", "requiredAddon": "gdpr_certification" }
          ]
        },
        {
          "title": "Healthcare",
          "route": "",
          "iconImg": "fa-hospital",
          "count": null,
          "sub_links": [
            { "title": "HIPAA Overview", "route": "/dashboard/hipaa-compliance", "iconImg": "fa-gauge-high", "count": null, "requiredFeature": "hipaa_compliance", "requiredAddon": "hipaa_certification" },
            { "title": "BAA Manager", "route": "/dashboard/hipaa-compliance/baa-manager", "iconImg": "fa-handshake", "count": null, "requiredFeature": "hipaa_compliance", "requiredAddon": "hipaa_certification" },
            { "title": "PHI Inventory", "route": "/dashboard/hipaa-compliance/phi-inventory", "iconImg": "fa-database", "count": null, "requiredFeature": "hipaa_compliance", "requiredAddon": "hipaa_certification" },
            { "title": "Risk Analysis", "route": "/dashboard/hipaa-compliance/risk-analysis", "iconImg": "fa-triangle-exclamation", "count": null, "requiredFeature": "hipaa_compliance", "requiredAddon": "hipaa_certification" },
            { "title": "Breach Notification", "route": "/dashboard/hipaa-compliance/breach-notification", "iconImg": "fa-bell", "count": null, "requiredFeature": "hipaa_compliance", "requiredAddon": "hipaa_certification" },
            { "title": "Safeguards", "route": "/dashboard/hipaa-compliance/safeguards", "iconImg": "fa-lock", "count": null, "requiredFeature": "hipaa_compliance", "requiredAddon": "hipaa_certification" }
          ]
        },
        {
          "title": "Government",
          "route": "",
          "iconImg": "fa-landmark-flag",
          "count": null,
          "sub_links": [
            { "title": "TX-RAMP", "route": "/dashboard/txramp-compliance", "iconImg": "fa-landmark-flag", "count": null, "requiredFeature": "txramp_compliance", "requiredAddon": "txramp_certification" },
            { "title": "FedRAMP", "route": "/dashboard/fedramp-compliance", "iconImg": "fa-landmark-flag", "count": null, "requiredFeature": "fedramp_compliance", "requiredAddon": "fedramp_certification" }
          ]
        }
      ]
    },
    {
      "title": "Threat Intelligence",
      "route": "",
      "iconImg": "fa-shield-virus",
      "count": null,
      "sub_links": [
        {
          "title": "Dark Web",
          "route": "",
          "iconImg": "fa-mask",
          "count": null,
          "sub_links": [
            { "title": "Findings", "route": "/dashboard/dark-web/findings", "iconImg": "fa-file-lines", "count": "0", "requiredFeature": "dark_web_monitoring", "requiredAddon": "dark_web_monitoring" },
            { "title": "Alerts", "route": "/dashboard/dark-web/alerts", "iconImg": "fa-bell", "count": "0", "requiredFeature": "dark_web_monitoring", "requiredAddon": "dark_web_monitoring" },
            { "title": "Settings", "route": "/dashboard/dark-web/settings", "iconImg": "fa-cog", "count": "0", "requiredFeature": "dark_web_monitoring", "requiredAddon": "dark_web_monitoring" }
          ]
        },
        {
          "title": "Vulnerabilities",
          "route": "",
          "iconImg": "fa-shield-virus",
          "count": null,
          "sub_links": [
            { "title": "CVE Library", "route": "/dashboard/cves", "iconImg": "fa-shield-virus", "count": null },
            { "title": "Management", "route": "/dashboard/vulnerability-management", "iconImg": "fa-network-wired", "count": null }
          ]
        }
      ]
    },
    {
      "title": "Remediation",
      "route": "",
      "iconImg": "fa-tools",
      "count": null,
      "sub_links": [
        { "title": "Projects", "route": "/dashboard/remediation-project", "iconImg": "fa-diagram-project", "count": null },
        { "title": "Automation", "route": "/dashboard/automation", "iconImg": "fa-gears", "count": null }
      ]
    },
    {
      "title": "Operations",
      "route": "",
      "iconImg": "fa-sliders",
      "count": null,
      "sub_links": [
        { "title": "Notifications", "route": "/dashboard/notification", "iconImg": "fa-bell", "count": "0" },
        { "title": "Schedule", "route": "/dashboard/calendar", "iconImg": "fa-calendar-days", "count": null },
        {
          "title": "Observability",
          "route": "",
          "iconImg": "fa-heart-pulse",
          "count": null,
          "sub_links": [
            { "title": "GPU Health", "route": "/dashboard/gpu-health", "iconImg": "fa-microchip", "count": null },
            { "title": "Availability", "route": "/dashboard/compliance/availability", "iconImg": "fa-server", "count": null }
          ]
        },
        { "title": "Audit Trail", "route": "/dashboard/company/audit-logs", "iconImg": "fa-clipboard-list", "count": null },
        { "title": "Reports", "route": "/dashboard/reports", "iconImg": "fa-file-lines", "count": null }
      ]
    },
    {
      "title": "Support",
      "route": "",
      "iconImg": "fa-question-circle",
      "count": null,
      "sub_links": [
        { "title": "View Tickets", "route": "/dashboard/support/list", "iconImg": "fa-list", "count": null },
        { "title": "Open Ticket", "route": "/dashboard/support/create", "iconImg": "fa-plus", "count": null }
      ]
    }
  ]
}
